// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"530e7eb6","350":"cea88cdd","469":"e162ad1d","826":"0efe6387"}[chunkId] + ".chunk.css";
};